import { Injectable } from '@angular/core';
import {
    CompanySupportInfo,
    CompanyCountsServer,
    CompanyGeneralSettingsServer,
    UserAccessibleCompanyServer
} from '../core-data-model/CompaniesApi.serverinterface';
import { Company } from '../core-data-model/Company.model';
import { CompanyCounts } from '../core-data-model/CompanyCounts.model';
import { SupportInfo } from '../core-data-model/SupportInfo.model';
import { CompaniesApiTransformer } from '../core-services/CompaniesApi.datatransform';
import { ToolboxTransformer } from '../core-services/Toolbox.datatransform';
import { ApiService } from '../system-services/Api.service';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';

@Injectable({
    providedIn: 'root'
})
export class CompaniesApi {
    constructor(
        private api: ApiService,
        private userProfile: UserProfileSettingsService,
        private companiesTransform: CompaniesApiTransformer,
        private toolboxTransformers: ToolboxTransformer
    ) {}
    getAllAccessibleCompanies(): Promise<Company[]> {
        return this.api
            .get<
                UserAccessibleCompanyServer[]
            >('/api/v4/companies/useraccessiblecompanies')
            .then(([response]) =>
                response.map((item) =>
                    this.companiesTransform.transformUserAccessibleCompanyServerToClient(
                        item
                    )
                )
            );
    }

    getGeneralSettings(): Promise<CompanyGeneralSettingsServer> {
        return this.api
            .get<CompanyGeneralSettingsServer>(
                `/api/v3/companies/${this.userProfile.currentCompany}/generalsetting`
            )
            .then(([data]) => data);
    }

    getAccountSupportInfo(): Promise<SupportInfo> {
        return this.api
            .get<CompanySupportInfo>(
                `/api/v1/companies/${this.userProfile.currentCompany}/supportInfo`
            )
            .then(([data]) => data);
    }

    getCompanyCounts(): Promise<CompanyCounts> {
        return this.api
            .get<CompanyCountsServer>(
                `/api/v3/companies/${this.userProfile.currentCompany}/companyCounts`
            )
            .then(([data]) => ({
                totalEmployees: data.employeeCount,
                totalTagged: data.totalEmployeesTaggedCount,
                totalAssessed: data.completedAssessmentsEmployeeCount,
                matchedReferenceProfilesInfo: data.matchedReferenceProfiles.map(
                    (refProf) => ({
                        employeeCount: refProf.employeeCount,
                        refProfileInfo:
                            this.toolboxTransformers.transformToRefProfile(
                                refProf.matchedReferenceProfile
                            )
                    })
                )
            }));
    }

    updateCompanySettings(newFieldEntries: any): Promise<any> {
        return this.api.patch<any>(
            `/api/v3/companies/${this.userProfile.currentCompany}/generalsetting`,
            newFieldEntries
        );
    }
}
